import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSupabaseAuth } from "../../SupabaseAuthContext";

/**
 * Protezione route (equivalente CRA del middleware Next su /dashboard).
 * Se Supabase non è configurato, lascia passare (auth legacy via accountMe nel figlio).
 */
export default function ProtectedRoute({ children, loginPath = "/accedi" }) {
  const { configured, session, loading } = useSupabaseAuth();
  const location = useLocation();

  if (!configured) {
    return children;
  }

  if (loading) {
    return (
      <div
        className="glow-tech-page flex items-center justify-center min-h-[40vh] px-5"
        data-testid="protected-route-loading"
        role="status"
      >
        <span className="font-mono text-sm text-ink2">Verifica accesso…</span>
      </div>
    );
  }

  if (!session) {
    return <Navigate to={loginPath} state={{ from: location.pathname }} replace />;
  }

  return children;
}
